export const UserEndpoints = {
  getUserDataByUcode: (ucode?: string) =>
    `${process.env.CONTENT_URL}/rest/v1/users/${ucode}/profile/summary`,
  getUserPostsByUcode: (ucode?: string) =>
    `${process.env.COMMUNITY_GATEWAY_URL}/v1/users/${ucode}/posts`
};
